import styled from 'styled-components';

export const ResponsesContainer = styled.div``;
